/* eslint-disable */
import {
  STORAGE_URL,
  SystemFolder,
  File,
  SYSTEM_OS,
  Auth,
} from 'commons/constants/KeyFlowConstants';

export function getCapacityUnit(unit) {
  if (unit === 1) {
    return 'KB';
  }

  if (unit === 2) {
    return 'MB';
  }

  if (unit === 3) {
    return 'GB';
  }

  if (unit === 4) {
    return 'TB';
  }

  if (unit === 5) {
    return 'PB';
  }

  if (unit === 6) {
    return 'EB';
  }

  return 'Bytes';
}

export function getCapacity(byte, unit) {
  let result = {
    capacity: byte / 1024 || 0,
    capacityUnit: unit || 1,
  };
  result.capacityValue = `${result.capacity.toFixed(2)} ${getCapacityUnit(result.capacityUnit)}`;

  if (result.capacity > 1000) {
    result.capacityUnit += 1;
    result = getCapacity(result.capacity, result.capacityUnit);
  }

  return result;
}

export function formattedDateString(dateString) {
  let formattedString = '';

  if (dateString) {
    if (/[0-9]{4}[0-1][0-9][0-3][0-9][0-2][0-9][0-5][0-9][0-5][0-9]/g.test(dateString)) {
      // eg. 20190612123124 yyyyMMddhhmiss
      formattedString += dateString.substring(0, 4);
      formattedString += '-';
      formattedString += dateString.substring(4, 6);
      formattedString += '-';
      formattedString += dateString.substring(6, 8);
      formattedString += ' ';
      formattedString += dateString.substring(8, 10);
      formattedString += ':';
      formattedString += dateString.substring(10, 12);
      formattedString += ':';
      formattedString += dateString.substring(12, 14);
    } else if (/[0-9]{4}[0-1][0-9][0-3][0-9]/g.test(dateString)) {
      // eg. 20190701 yyyyMMdd
      formattedString += dateString.substring(0, 4);
      formattedString += '/';
      formattedString += dateString.substring(4, 6);
      formattedString += '/';
      formattedString += dateString.substring(6, 8);
    } else {
      formattedString = dateString;
    }
  }

  return formattedString;
}

/**
 * @param {*} seconds
 * @param {*} format
 * @param {*} type
 *  true  : 01시 01분 01초
 *  false : 1시 1분 1초
 */
export function timeFormat(seconds, format, type) {
  const date = new Date(seconds * 1000);
  // console.log({date});
  const hh = date.getUTCHours() < 10 && !type ? `0${date.getUTCHours()}` : date.getUTCHours();
  let mm = date.getUTCMinutes() < 10 && !type ? '0' + date.getUTCMinutes() : date.getUTCMinutes();
  let ss = date.getSeconds() < 10 && !type ? '0' + date.getSeconds() : date.getSeconds();
  let ms = date.getMilliseconds();

  let result = format;

  if (format) {
    result = result.replace(/hh/gi, hh);
    result = result.replace(/mm/gi, mm);
    result = result.replace(/ss/gi, ss);
    result = result.replace(/ms/gi, ms);
  } else {
    result = hh + ':' + mm + ':' + ss + '.' + ms;
  }

  return result;
}

export const calculateHourToSecond = (hour, min, sec) => {
  return parseInt(hour, 10) * 60 * 60 + parseInt(min, 10) * 60 + parseInt(sec, 10);
};

export const calculateWidthToPercent = (overallWidth, mouseX) => {
  let percent = mouseX / overallWidth;
  if (percent <= 0) percent = 0;
  if (percent >= 1) percent = 1;

  return percent;
};

export function makePageList(pageNumber, pageCount) {
  const pageList = [];
  let startIndex = 0;
  let lastIndex = 5;

  if (pageNumber > 2 && pageNumber < pageCount - 2) {
    startIndex = pageNumber - 2;
    lastIndex = pageNumber + 3;
  } else if (pageNumber >= pageCount - 2) {
    startIndex = pageCount - 5;
    lastIndex = pageCount;
    if (pageCount < 5) startIndex = 0;
  }

  for (let i = startIndex; i < lastIndex; i++) {
    if (i >= pageCount) break;
    pageList.push(i);
  }

  return pageList;
}

export class AssetUrlBuilder {
  constructor(type, symbolicPath, categoryId, fileName, dateOfChangedThumbnail) {
    this.type = type;
    this.symbolicPath = symbolicPath;
    this.categoryId = categoryId;
    this.fileName = fileName;
    this.dateOfChangedThumbnail = dateOfChangedThumbnail;
  }

  setType(type) {
    this.type = type || '';
    return this;
  }

  setSymbolicPath(symbolicPath) {
    this.symbolicPath = symbolicPath || '';
    return this;
  }

  setCategoryId(categoryId) {
    this.categoryId = categoryId || '';
    return this;
  }

  setFileName(fileName) {
    this.fileName = fileName || '';
    return this;
  }

  setVideoId(videoId) {
    this.videoId = videoId || '';
    return this;
  }

  setDateOfChangedThumbnail(dateOfChangedThumbnail) {
    this.dateOfChangedThumbnail = dateOfChangedThumbnail || '';
    return this;
  }

  reload() {
    this._dateOfChangedThumbnail !== null
      ? (this.fileName += `?time=${this.dateOfChangedThumbnail}`)
      : (this.fileName += `?time=${Date.now()}`);
    return this;
  }

  build() {
    switch (this.type) {
      case File.HIRES:
        return `${STORAGE_URL}${this.symbolicPath}/${SystemFolder.HIRES_FOLDER_NAME}/${this.categoryId}/${this.fileName}`;
      case File.LOWRES:
        return `${STORAGE_URL}${this.symbolicPath}/${SystemFolder.LOWRES_FOLDER_NAME}/${this.categoryId}/${this.fileName}`;
      case File.THUMBNAIL:
        return `${STORAGE_URL}${this.symbolicPath}/${SystemFolder.THUMBNAIL_FOLDER_NAME}/${this.categoryId}/${this.fileName}`;
      case File.SKIM:
        return `${STORAGE_URL}${this.symbolicPath}/${SystemFolder.SKIM_FOLDER_NAME}/${this.categoryId}/${this.fileName}`;
      case File.ATTACH:
        return `${STORAGE_URL}${this.symbolicPath}/${SystemFolder.ATTACH_FOLDER_NAME}/${this.categoryId}/${this.fileName}`;
      case File.SCRIPT:
        return `${STORAGE_URL}${this.symbolicPath}/${SystemFolder.SCRIPT_FOLDER_NAME}/${this.categoryId}/${this.videoId}/${this.fileName}`;
      default:
        return `${STORAGE_URL}${this.symbolicPath}`;
        break;
    }
  }
}

export class AssetNasPathBuilder {
  constructor(os, type, storagePath, categoryId, fileName, title) {
    this.os = os;
    this.storagePath = storagePath;
    this.categoryId = categoryId;
    this.title = title;
    this.isContainTitle = false;

    this.fileName = fileName;
    this.type = type;

    this.seperator = SYSTEM_OS.WINDOWS ? '\\' : '/';
  }

  setOs(os) {
    this.os = os;
    if (os === SYSTEM_OS.WINDOWS) {
      this.seperator = '\\';
    }
    if (os === SYSTEM_OS.MAC) {
      this.seperator = '/';
    }
    return this;
  }

  setType(type) {
    this.type = type;
    return this;
  }

  setStoragePath(storagePath) {
    this.storagePath = storagePath;
    return this;
  }

  setCategoryId(categoryId) {
    this.categoryId = categoryId;
    return this;
  }

  setFileName(fileName) {
    this.fileName = fileName;
    return this;
  }

  setTitle(title) {
    this.title = title;
    return this;
  }

  setIsContainTitle(isContainTitle) {
    this.isContainTitle = isContainTitle;
    return this;
  }

  build() {
    switch (this.type) {
      case File.HIRES:
        return this.isContainTitle
          ? `${this.storagePath}${this.seperator}${SystemFolder.HIRES_FOLDER_NAME}${this.seperator}${this.categoryId}${this.seperator}${this.fileName}, ${this.title}`
          : `${this.storagePath}${this.seperator}${SystemFolder.HIRES_FOLDER_NAME}${this.seperator}${this.categoryId}${this.seperator}${this.fileName}`;
      case File.LOWRES:
        return `${this.storagePath}${this.seperator}${SystemFolder.LOWRES_FOLDER_NAME}${this.seperator}${this.categoryId}${this.seperator}${this.fileName}`;
      case File.THUMBNAIL:
        return `${this.storagePath}${this.seperator}${SystemFolder.THUMBNAIL_FOLDER_NAME}${this.seperator}${this.categoryId}${this.seperator}${this.fileName}`;
      case File.SKIM:
        return `${this.storagePath}${this.seperator}${SystemFolder.SKIM_FOLDER_NAME}${this.seperator}${this.categoryId}${this.seperator}${this.fileName}`;
      default:
        return null;
    }
  }
}

export function eventPropagationPrevent(event) {
  event.preventDefault();
  event.stopPropagation();
}

/*
  [파일명으로 사용할수 없는 특수문자]
    .'"/\:*?<>|

  [URL 파라미터로 사용할수 없는 특수문자]
    /\=&%?;,
*/
export function isContainSpecialCharacter(keyword) {
  const regExp = /[/\\=&%?;,]/gi;
  const result = regExp.test(keyword);
  return result;
}

export function encodeSpecialCharacter(keyword, alterCharacter) {
  const regExp = /[/\\=&%?;,]/gi;
  let result = keyword || '';
  const alter = alterCharacter || '';

  if (regExp.test(keyword)) {
    result = keyword.replace(regExp, alter);
  }

  return result;
}

export function convertUnderscoreToCamelcase(keyword) {
  const regExp = /_+([a-z])/g;
  let _keyword = keyword.toLowerCase();
  let result = _keyword;

  if (regExp.test(_keyword)) {
    result = _keyword.replace(regExp, match => {
      return match.substring(match.length - 1).toUpperCase();
    });
  }

  return result;
}

export function makeSeasonList(total) {
  const thisYear = new Date().getFullYear();
  const seasonList = [];
  total && seasonList.push({ id: '-1', name: '전체' });

  for (let i = 0; i < 20; i++) {
    seasonList.push({ id: String(thisYear - i), name: String(thisYear - i) });
  }

  return seasonList;
}

export function formatDate(date) {
  if (date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  } else {
    return '';
  }
}

export function assetWithToken(url) {
  const accessToken = localStorage.getItem(Auth.ACCESS_TOKEN);
  return `${url}?ACCESS_TOKEN=${accessToken}`;
}

export function assetWithOutToken(url) {
  return `${url}`;
}

export function addComma(num) {
  if (isNaN(num)) return num;
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
